export default "__VITE_ASSET__TX4vynAO__"